// import React from "react";
// import { Link } from "react-router-dom";
// import "../Styles/Footer.css";
// import { MdAddCall, MdEmail } from "react-icons/md";
// import {
//   FaWhatsapp,
//   FaFacebookF,
//   FaInstagram,
//   FaLinkedinIn,
// } from "react-icons/fa";
// import { FaXTwitter } from "react-icons/fa6";
// import { IoLogoTiktok } from "react-icons/io5";

// function Footer() {
//   return (
//     <div className="footer-container">
//       <div className="footer-main">
//         <div className="contacts">
//           <h3>Contacts</h3>
//           <div>
//             <Link to={"tel:+254741210060"}>
//               <MdAddCall /> Call Us
//             </Link>
//           </div>
//           <div>
//             <Link to={"https://wa.me/254741210060"} style={{ color: "green" }}>
//               <FaWhatsapp /> WhatsApp Us
//             </Link>
//           </div>
//           <div>
//             <Link to={"mailto:cmwenda20@gmail.com"}>
//               <MdEmail /> Email Us
//             </Link>
//           </div>
//         </div>
//         <div className="social-media">
//           <h3>Social Media</h3>
//           <div>
//             <Link to={"https://www.facebook.com/kingcolloh0"}>
//               <FaFacebookF /> FusionXe
//             </Link>
//           </div>
//           <div>
//             <Link to={"https://www.instagram.com/collinmwenda254"}>
//               <FaInstagram /> FusionXe
//             </Link>
//           </div>
//           <div>
//             <Link to={"https://x.com/mwenda_collin"}>
//               <FaXTwitter />
//               FusionXe
//             </Link>
//           </div>
//           <div>
//             <Link
//               to={"https://www.tiktok.com/@king_colloh0?_t=8mtwN91lTQD&_r=1"}
//             >
//               <IoLogoTiktok /> FusionXe
//             </Link>
//           </div>
//           <div>
//             <Link
//               to={
//                 "https://www.linkedin.com/in/collin-mwenda-software-engineer/"
//               }
//             >
//               <FaLinkedinIn /> FusionXe
//             </Link>
//           </div>
//         </div>
//         <div className="quick-links">
//           <h3>Quick Links</h3>
//           <div>
//             <Link to={"https://kibandaskii.vercel.app/"}>Shop With Us</Link>
//           </div>
//           <div>
//             <Link to={"/Products"}>Our Products</Link>
//           </div>
//           <div>
//             <Link to={"/Services"}>Our Services</Link>
//           </div>
//           <div>
//             <Link to={"/inquiry"}>Send Enquiry</Link>
//           </div>
//           <div>
//             <Link to={"https://calendly.com/cmwenda20"}>
//               Book an Appointment
//             </Link>
//           </div>
//         </div>
//         <div className="our-products">
//           <h3>Our Products</h3>
//           <div>
//             <Link to={"/kidsmatter"}>Kids Matter</Link>
//           </div>
//           <div>
//             <Link to={"/schlapp"}>School App</Link>
//           </div>
//           <div>
//             <Link to={"/social"}>Social</Link>
//           </div>
//         </div>
//       </div>
//       <p className="text-center font-bold" title="Company's CEO">
//         &copy;{new Date().getFullYear()} FusionXe Solutions. All Rights
//         Reserved. Developed by{" "}
//         <Link to={"https://collinm254.github.io/Portfolio1/"} style={{color: "white", textDecoration: "none"}}>Collin</Link>
//       </p>
//     </div>
//   );
// }

// export default Footer;


import React from "react";
import { Link } from "react-router-dom";
import {
  MdEmail,
  MdPhone,
  MdLocationOn,
  MdAccessTime,
} from "react-icons/md";
import {
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
  FaGithub,
  FaInstagram,
  FaYoutube,
  FaWhatsapp,
} from "react-icons/fa";

import "../Styles/Footer.css";

function Footer() {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: "Home", path: "/" },
    { name: "Services", path: "/services" },
    { name: "Products", path: "/products" },
    { name: "AI Solutions", path: "/ai" },
    { name: "Portfolio", path: "/portfolio" },
    { name: "Blog", path: "/blog" },
  ];

  const services = [
    { name: "Web Development", path: "/services/web" },
    { name: "Mobile Apps", path: "/services/mobile" },
    { name: "AI Integration", path: "/services/ai" },
    { name: "Cloud Solutions", path: "/services/cloud" },
    { name: "E-commerce", path: "/services/ecommerce" },
    { name: "Digital Marketing", path: "/services/marketing" },
  ];

  const products = [
    { name: "KidsEdu AI", path: "https://kidsedu.fusion-xe.com" },
    { name: "Fusion-Xe AI Suite", path: "/products/ai-suite" },
    { name: "Enterprise Cloud", path: "/products/cloud" },
    { name: "School Management", path: "/products/school" },
    { name: "Hospital Systems", path: "/products/hospital" },
  ];

  const socialLinks = [
    { icon: <FaFacebookF />, href: "https://facebook.com/fusionxe" },
    { icon: <FaTwitter />, href: "https://twitter.com/fusionxe" },
    { icon: <FaLinkedinIn />, href: "https://linkedin.com/company/fusionxe" },
    { icon: <FaGithub />, href: "https://github.com/fusionxe" },
    { icon: <FaInstagram />, href: "https://instagram.com/fusionxe" },
    { icon: <FaYoutube />, href: "https://youtube.com/fusionxe" },
    { icon: <FaWhatsapp />, href: "https://wa.me/254741210060" },
  ];

  const contactInfo = [
    { icon: <MdEmail />, text: "info@fusion-xe.com", link: "mailto:info@fusion-xe.com" },
    { icon: <MdEmail />, text: "sales@fusion-xe.com", link: "mailto:sales@fusion-xe.com" },
    { icon: <MdEmail />, text: "support@fusion-xe.com", link: "mailto:support@fusion-xe.com" },
    { icon: <MdEmail />, text: "kidsedu@fusion-xe.com", link: "mailto:kidsedu@fusion-xe.com" },
    { icon: <MdPhone />, text: "+254-111-999-685", link: "tel:+254741210060" },
    { icon: <MdLocationOn />, text: "Nairobi, Kenya", link: "#" },
    { icon: <MdAccessTime />, text: "24/7 Support Available", link: "#" },
  ];

  return (
    <footer className="footer-container">
      <div className="footer-main">
        {/* Company Info */}
        <div className="footer-section">
          <div className="company-logo">
            <span className="logo-text">Fusion-Xe</span>
            <span className="logo-tagline">AI-Driven Innovation</span>
          </div>
          <p className="company-description">
            We build futuristic software solutions powered by artificial intelligence 
            to revolutionize businesses and create meaningful impact worldwide.
          </p>
          <div className="social-links-footer">
            {socialLinks.map((social, index) => (
              <a
                key={index}
                href={social.href}
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon"
              >
                {social.icon}
              </a>
            ))}
          </div>
        </div>

        {/* Quick Links */}
        <div className="footer-section">
          <h3>Quick Links</h3>
          <ul className="footer-links">
            {quickLinks.map((link, index) => (
              <li key={index}>
                <Link to={link.path}>{link.name}</Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Services */}
        <div className="footer-section">
          <h3>Our Services</h3>
          <ul className="footer-links">
            {services.map((service, index) => (
              <li key={index}>
                <Link to={service.path}>{service.name}</Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Products */}
        <div className="footer-section">
          <h3>Our Products</h3>
          <ul className="footer-links">
            {products.map((product, index) => (
              <li key={index}>
                <a href={product.path} target="_blank" rel="noopener noreferrer">
                  {product.name}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact Info */}
        <div className="footer-section">
          <h3>Contact Us</h3>
          <ul className="contact-info">
            {contactInfo.map((info, index) => (
              <li key={index}>
                <a href={info.link}>
                  {info.icon}
                  <span>{info.text}</span>
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="footer-bottom">
        <div className="footer-bottom-content">
          <p>
            &copy; {currentYear} Fusion-Xe Solutions. All Rights Reserved.
            <span className="separator">|</span>
            <Link to="/privacy">Privacy Policy</Link>
            <span className="separator">|</span>
            <Link to="/terms">Terms of Service</Link>
            <span className="separator">|</span>
            <Link to="/sitemap">Sitemap</Link>
          </p>
          <p className="developed-by">
            Developed by{" "}
            <a href="https://collinm254.github.io/Portfolio1/" target="_blank" rel="noopener noreferrer">
              Collin Mwenda
            </a>
          </p>
        </div>
      </div>

      {/* SEO Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "Fusion-Xe Solutions",
          "url": "https://fusion-xe.com",
          "logo": "https://fusion-xe.com/logo.png",
          "sameAs": [
            "https://facebook.com/fusionxe",
            "https://twitter.com/fusionxe",
            "https://linkedin.com/company/fusionxe",
            "https://instagram.com/fusionxe"
          ],
          "contactPoint": {
            "@type": "ContactPoint",
            "telephone": "+254-111-999-685",
            "contactType": "customer service",
            "email": "info@fusion-xe.com",
            "areaServed": "Worldwide",
            "availableLanguage": ["English", "Swahili"]
          },
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Nairobi",
            "addressCountry": "KE"
          }
        })}
      </script>
    </footer>
  );
}

export default Footer;